import axios from './axiosInstance';

const BASE = process.env.REACT_APP_ALI_URL || 'https://api.mazesai.com/aliapi/';

export const searchGeneralProducts = async (keyWord = '', categoryId = '', pageIndex = 1) => {
  const payload = new URLSearchParams();
  payload.append('pageIndex', String(pageIndex));
  payload.append('keyWord', keyWord.trim() || 'auto parts');
  if (categoryId) payload.append('categoryId', categoryId);

  try {
    const res = await axios.post(`${BASE}products/search/`, payload, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return res.data;
  } catch (error) {
    console.error('Error fetching products:', error);
    return {};
  }
};

export async function getCategoryHierarchy() {
  const res = await fetch(`${BASE}categories/hierarchy/`);
  return res.json();
}

export async function getProductDetail(productId) {
  const res = await fetch(`${BASE}products/${productId}/`);
  return res.json();
}

export async function getShipping(productId, sku_id, ship_to = 'NG') {
  const res = await fetch(
    `${BASE}products/${productId}/shipping/?sku_id=${sku_id}&ship_to=${ship_to}`
  );
  return res.json();
}
